import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CoinIcon } from "@/components/Icons";
import Avatar from "@/components/Avatar";

const MEDALS = ["🥇", "🥈", "🥉"];

export default function TopFans({ targetId }) {
  const [fans, setFans] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/users/${targetId}/top-fans`).then(({ data }) => setFans(data.top_fans)).catch(() => {});
  }, [targetId]);

  if (fans.length === 0) return null;

  return (
    <div className="glass rounded-2xl p-4 mt-8" data-testid="top-fans-strip">
      <h2 className="text-sm font-bold text-zinc-200 font-display mb-3">💖 Top Fans</h2>
      <div className="flex gap-4 overflow-x-auto no-scrollbar">
        {fans.map((f, i) => (
          <button
            key={f.user.id}
            data-testid={`top-fan-${f.user.id}`}
            onClick={() => navigate(`/profile/${f.user.id}`)}
            className="flex flex-col items-center gap-1 shrink-0 active:scale-95 transition-transform"
          >
            <div className="relative">
              <Avatar src={f.user.avatar} size={46} tier={f.user.tier} />
              <span className="absolute -top-2 -right-1.5 text-sm">{MEDALS[i] || ""}</span>
            </div>
            <span className="text-[10px] text-white font-semibold max-w-[64px] truncate">{f.user.name}</span>
            <span className="text-[9px] text-amber-400 font-bold flex items-center gap-0.5"><CoinIcon size={10} /> {f.total.toLocaleString()}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
